import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import { devConfig, profile } from 'config/config'; // Importing configuration and profile settings
import 'webix/photo'; // Importing Webix photo component
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix

export default class FilterBonusReportView extends JetView {
    // Defining the FilterBonusReportView class
    config() {
        // Method to define the view configuration
        const _ = this.app.getService('locale')._; // Localization service for translations
        const screen = this.app.config.size; // Getting the screen size configuration
        const left = {
            // Configuration for the left section of the form
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Dropdown for selecting result date type
                    name: 'ResultDate',
                    localId: 'timeTypes:combo',
                    label: _('Tipo de tiempo'), // Translated label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options will be populated dynamically
                },
                {
                    view: 'richselect', // Dropdown for selecting bonus type
                    name: 'BonusType',
                    localId: 'bonusTypes:combo',
                    label: _('Tipo'), // Translated label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options will be populated dynamically
                },
            ],
        };
        const center_left = {
            // Configuration for the center-left section of the form
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for date range
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true, // Read-only input
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Translated label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
                {
                    view: 'datepicker', // Datepicker for selecting a date
                    name: 'Date',
                    id: 'Date',
                    stringResult: true, // Return date as a string
                    minWidth: 200,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Translated label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                    format: '%d %M %Y', // Date format
                    suggest: {
                        type: 'calendar', // Suggestion type
                        body: {
                            maxDate: new Date(), // Maximum selectable date is today
                        },
                    },
                },
                {
                    view: 'richselect', // Dropdown for selecting acceptance type
                    name: 'AcceptanceType',
                    localId: 'bonusStates:combo',
                    label: _('Estado'), // Translated label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options will be populated dynamically
                },
            ],
        };
        const center_right = {
            // Configuration for the center-right section of the form
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for client bonus ID
                    name: 'ClientBonusId',
                    type: 'number', // Input type is number
                    label: _('Partner Bono Id'), // Translated label
                    labelPosition: 'top',
                    placeholder: _('Partner Bono Id'), // Placeholder text
                    invalidMessage: _('Partner Bonus Id is required'), // Error message if input is invalid
                },
            ],
        };
        const right = {
            // Configuration for the right section of the form
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for partner bonus ID
                    name: 'PartnerBonusId',
                    type: 'number', // Input type is number
                    label: _("<span class='icon-id'></span> ID"), // Translated label with icon
                    labelPosition: 'top',
                    placeholder: _('ID'), // Placeholder text
                    invalidMessage: _('ID is required'), // Error message if input is invalid
                },
            ],
        };
        const upper_section = {
            // Upper section containing form fields
            id: 'a1',
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 370 : 0, // Responsive height based on screen width
            rows: [
                {
                    responsive: 'a1', // Responsive layout
                    margin: 10,
                    cols: [left, center_left, center_right, right], // Columns for different sections
                },
            ],
        };
        const buttons = {
            // Configuration for action buttons
            margin: 10,
            minWidth: 200,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Translated label
                    autowidth: true,
                    click: () => {
                        // Click event to clear the form
                        this.getRoot().clear();
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Translated label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        // Click event to handle form submission
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            // Conditional logic based on profile type
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                // Placeholder for additional logic
                                delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('bonusReport:filter', [filterdata]); // Trigger filter event with form data
                        $$('b5').collapse(); // Collapse the accordion section
                    },
                },
            ],
        };
        const accordion_section = {
            // Configuration for the accordion section
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion view for collapsible sections
                    css: 'betShop',
                    collapsed: false, // Initially expanded
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Translated header for filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        return {
            // Return the main form configuration
            view: 'form',
            type: 'clean',
            rows: [accordion_section], // Include accordion section in the form
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
    init(grid) {
        // Initialization method for the view
        webix.ready(function () {
            // Ensure Webix is ready before executing
            if (profile.typeDate !== 2) {
                // Conditional logic based on profile type
                $$('Date').hide(); // Hide Date input if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    // Placeholder for additional logic
                    $$('Date').show(); // Show Date input if typeDate is 2
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language setting
        $$('Datepicker').attachEvent('onAfterRender', function () {
            // Event after Datepicker is rendered
            devConfig.setDateModal(lang); // Set date modal configuration based on language
        });
    }
}

// FILE DOCUMENTED
